// © 2025 Camp Promethean, LLC. All Rights Reserved.

export function LightLabTooltipContent() {
  return (
    <div className="space-y-2.5 text-xs leading-relaxed">
      <p className="text-sm font-medium">Light Lab</p>
      <p>
        Lighting calculators for PPFD, DLI, photoperiod ramps, spectrum, and fixture energy
        efficiency — built for daily cultivation planning.
      </p>
      <div>
        <p className="font-medium">Modules</p>
        <ul className="mt-1 list-disc space-y-0.5 pl-4">
          <li>DLI core — solve for DLI, PPFD, or photoperiod from any two inputs</li>
          <li>DLI ramp — plan intensity and photoperiod week by week across phases</li>
          <li>Spectrum — explore channel mix, SPD, and key spectral ratios</li>
          <li>Energy — convert wattage and PPE into PPFD, DLI, kWh, and cost</li>
        </ul>
      </div>
      <div>
        <p className="font-medium">How to use</p>
        <ol className="mt-1 list-decimal space-y-0.5 pl-4">
          <li>Pick a module tab at the top of Light Lab.</li>
          <li>Enter your fixture or room parameters — results update live.</li>
          <li>Use DLI core for quick checks; ramp and energy for longer-range planning.</li>
        </ol>
      </div>
      <p className="text-muted-foreground">
        Pair with Cultivation Targets to align light setpoints with your crop phase schema.
      </p>
    </div>
  );
}
